import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { PaginatedSelect } from '../../../../../src/component/PaginatedSelect';
import { OptionType } from '../../../../../src/component/PaginatedSelect/type';
import { useAuth } from '../../auth/AuthProvider';
import { ActionInput } from '../../common/ActionInput';
import { useClientOptions } from './hooks';
import styles from './styles.module.scss';

export const ServiceUsageTableFilter = () => {
  const [filterParams, setFilterParams] = useSearchParams();
  const [selectedClient, setSelectedClient] = useState<OptionType | null | undefined>(() => {
    const clientName = filterParams.get('client[name]');
    return clientName ? { label: clientName, value: clientName } : null;
  });
  const { signOut } = useAuth();
  const { searchAction } = useClientOptions({ signOut });

  const updateFilterParams = (key: string, value: string) => {
    const newParams = new URLSearchParams(filterParams);
    if (value) {
      newParams.set(key, value);
    } else {
      newParams.delete(key);
    }
    setFilterParams(newParams);
  };

  return (
    <div className={styles.root}>
      <div className={styles.form}>
        <label htmlFor='user[name]' className={styles.formTitle}>
          ユーザー名
        </label>
        <ActionInput
          id='user[name]'
          defaultValue={filterParams.get('user[name]') || ''}
          action={e => updateFilterParams('user[name]', e.target.value)}
          placeholder='福利 くらら'
        />
      </div>
      <div className={styles.form}>
        <label htmlFor='client[name]' className={styles.formTitle}>
          クライアント名
        </label>
        <PaginatedSelect
          searchAction={searchAction}
          isClearable={true}
          value={selectedClient}
          placeholder='クライアント名'
          onChange={e => {
            setSelectedClient(e);
            updateFilterParams('client[name]', e?.label ?? '');
          }}
        />
      </div>
    </div>
  );
};
